export class ResourceCreationSteps {
    static FAILED = 0;
    static STEP1 = 1;
    static STEP2 = 2;
    static STEP3 = 3;
    static STEP4 = 4;
}
